import React from "react";
import { Horizontal } from "./Horizontal";
import { Textbox } from "Inputs/Textbox";
import { StateSelectDropdown } from "Inputs/StateSelectDropdown";

export function AddressInputs(props: {
  isRequired?: boolean;
  label: React.ReactNode;
}) {
  return (
    <>
      <Horizontal isRequired={props.isRequired} label={props.label}>
        <Textbox fieldName="Address1" placeholder="Mailing Address 1" />
      </Horizontal>
      <Horizontal>
        <Textbox fieldName="Address2" placeholder="Mailing Address 2" />
      </Horizontal>
      <Horizontal>
        <Textbox fieldName="City" placeholder="City" />
        <StateSelectDropdown fieldName="State" />
        <Textbox type="tel" fieldName="ZipCode" placeholder="Zip Code" />
      </Horizontal>
    </>
  );
}
